import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { api } from "../../lib/api";
import { apiError } from "../../lib/auth";

const STARTERS = ["Will this work for coaching?", "Do you submit without me?", "How much does it cost?"];

export const MariChat = () => {
  const [msgs, setMsgs] = useState([{ role: "mari", text: "Hi, I'm MARI. Ask me anything about AEGIS Guard: how it works, whether it fits your business, or what it costs." }]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const sid = useRef(sessionStorage.getItem("aegis-public-chat") || null);
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "nearest", behavior: "smooth" }); }, [msgs]);

  const send = async (q) => {
    const m = (q ?? text).trim();
    if (!m || busy) return;
    setText(""); setBusy(true);
    setMsgs((x) => [...x, { role: "user", text: m }]);
    try {
      const { data } = await api.post("/public/mari-chat", { message: m, session_id: sid.current });
      sid.current = data.session_id; sessionStorage.setItem("aegis-public-chat", data.session_id);
      setMsgs((x) => [...x, { role: "mari", text: data.reply }]);
    } catch (e) { setMsgs((x) => [...x, { role: "mari", text: apiError(e) }]); }
    setBusy(false);
  };

  return (
    <div className="border border-white/10 bg-white/[0.02] max-w-3xl" data-testid="public-mari-chat">
      <div className="h-80 overflow-y-auto p-5 space-y-4" data-testid="public-chat-messages">
        {msgs.map((m, i) => (
          <div key={i} className={m.role === "user" ? "text-right" : ""}>
            <p className="font-mono text-[10px] tracking-[0.2em] text-white/35">{m.role === "user" ? "YOU" : "MARI"}</p>
            <p className={`inline-block text-sm mt-1 max-w-[85%] text-left whitespace-pre-line ${m.role === "user" ? "text-white" : "text-white/80"}`} data-testid={`public-chat-msg-${i}`}>{m.text}</p>
          </div>
        ))}
        {busy && <p className="font-mono text-xs text-brand animate-pulse" data-testid="public-chat-thinking">MARI is thinking…</p>}
        <div ref={end} />
      </div>
      <div className="flex flex-wrap gap-2 px-5 pb-3">
        {STARTERS.map((s) => <button key={s} onClick={() => send(s)} className="font-mono text-[10px] px-3 py-1.5 border border-white/15 hover:border-brand transition-colors" data-testid={`public-chat-starter-${s.split(" ")[0].toLowerCase()}`}>{s}</button>)}
      </div>
      <form onSubmit={(e) => { e.preventDefault(); send(); }} className="flex border-t border-white/10">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Ask MARI…" maxLength={600} className="flex-1 bg-transparent px-5 py-4 text-sm focus:outline-none" data-testid="public-chat-input" />
        <button type="submit" disabled={busy} className="px-5 text-brand disabled:opacity-40" data-testid="public-chat-send"><Send className="w-4 h-4" /></button>
      </form>
    </div>
  );
};
